// extracted by mini-css-extract-plugin
module.exports = {"skeleton_box":"skeleton_skeleton_box__pEomF","shimmer":"skeleton_shimmer__X5miL"};